import type { IDashboardRepository } from '@/core/domain/dashboard/IDashboardRepository'
import type { ClassroomDiagnosticStudentResult } from '@/core/domain/dashboard/ClassroomDiagnosticStudentResult'

/**
 * Use case pour récupérer les résultats de diagnostic d'une classe
 */
export class FetchClassroomDiagnosticResultsUseCase {
  private dashboardRepository: IDashboardRepository

  constructor(dashboardRepository: IDashboardRepository) {
    this.dashboardRepository = dashboardRepository
  }

  async execute(
    schoolId: number,
    periodId: number,
    schoolClassroomId: number
  ): Promise<ClassroomDiagnosticStudentResult[]> {
    return await this.dashboardRepository.fetchClassroomDiagnosticResults(
      schoolId,
      periodId,
      schoolClassroomId
    )
  }
}
